define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaSysStatusDomain = void 0;
    class WaSysStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaSysStatusDomain.Active, value: "Active" },
                    { key: WaSysStatusDomain.Archived, value: "Archived" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaSysStatusDomain.Active] = 0;
                this.KeyIndex[WaSysStatusDomain.Archived] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Active"] = 0;
                this.ValueIndex["Archived"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaSysStatusDomain = WaSysStatusDomain;
    Object.defineProperty(WaSysStatusDomain, "Active", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaSysStatusDomain, "Archived", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaSysStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
